import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getGreeting } from "../../utils/timeUtils";

const Greeting = ({ username }) => {
  const [greeting, setGreeting] = useState(getGreeting());

  useEffect(() => {
    const interval = setInterval(() => {
      setGreeting(getGreeting());
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      className="greeting"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1>
        {greeting}, {username}!
      </h1>
    </motion.div>
  );
};

export default Greeting;
